import script from "./doorpointsSettle.vue?vue&type=script&setup=true&lang=js"
export * from "./doorpointsSettle.vue?vue&type=script&setup=true&lang=js"

import "./doorpointsSettle.vue?vue&type=style&index=0&id=2e5f1200&lang=scss"

const __exports__ = script;

export default __exports__